<template>
    <div class="card" style="margin-bottom: 15px;" >
        <bid-header :bid="bid"></bid-header>
        <div class="card-content">
            <bid-content :bid="bid"></bid-content>
        </div>
    </div>
</template>

<script>
    import bidHeader from './Headers/BidHeader.vue'
    import bidContent from './Content/BidContent.vue'
    export default {
        components: {
            bidHeader: bidHeader,
            bidContent: bidContent
        },
        props: ['bid'],
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Card/BidLayout.vue